import { DefaultPrimaryButton, DefaultSecondaryButton, Spinner } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { KioskNavigationFooter } from '../../components/kiosk-navigation-footer.component';
import { KioskNavigationHeader } from '../../components/kiosk-navigation-header.component';
import KioskRadioButton from '../../components/kiosk-radio-button/kiosk-radio-button.component';
import { useBulkMoveSelectSpot } from './bulk-move-select-spot.controller';

const ID = 'bulk-move-select-spot';

const BulkMoveSelectSpot = () => {
    const viewProps = useBulkMoveSelectSpot();

    return (
        <div
            id={ID}
            className='bg-background-default flex size-full flex-col overflow-hidden'>
            <KioskNavigationHeader
                title={CommonMessage.DETAIL.MANAGE(CommonMessage.OBJECTS.SPOT.DISTRI_SPOT)}
                onBack={viewProps.handleBack}
            />
            <div className='flex flex-1 flex-col gap-4 overflow-y-auto p-6'>
                {viewProps.isLoading && (
                    <div className='flex flex-1 items-center justify-center'>
                        <Spinner />
                    </div>
                )}
                {!viewProps.isLoading && viewProps.error && <div className='text-status-danger'>{viewProps.error}</div>}
                {!viewProps.isLoading && !viewProps.error && (
                    <>
                        <p className='text-foreground-default text-lg font-semibold'>
                            <FormattedMessage
                                id='kiosk.manage-spot.bulk-move-transactions.select-spot.title'
                                defaultMessage='Select destination {distriSpot}'
                                description='Title on the bulk move destination distriSPOT selection screen'
                                values={{ distriSpot: CommonMessage.OBJECTS.SPOT.DISTRI_SPOT }}
                            />
                        </p>
                        <div className='flex w-full flex-col gap-3'>
                            {viewProps.spots.map((spot) => (
                                <KioskRadioButton
                                    key={spot.id}
                                    id={`${ID}-${spot.id}`}
                                    text={spot.name}
                                    selected={viewProps.selectedSpotId === spot.id}
                                    onClick={() => viewProps.setSelectedSpotId(spot.id)}
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>
            <KioskNavigationFooter
                leftButton={
                    <DefaultSecondaryButton
                        text={CommonMessage.BUTTONS.GO_BACK}
                        onClick={viewProps.handleBack}
                    />
                }
                rightButton={
                    <DefaultPrimaryButton
                        text={CommonMessage.BUTTONS.CONTINUE}
                        onClick={viewProps.handleContinue}
                        disabled={!viewProps.canContinue}
                    />
                }
            />
        </div>
    );
};

export default BulkMoveSelectSpot;
